import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';

// Regalo: demo gratuita del Día 1. Suscribe el email a la lista "Demo Día 1" de Klaviyo (Uw3FLb).
// El flujo de Klaviyo envía el enlace a la demo. No pasa por el checkout.
const KLAVIYO_COMPANY = 'Ydeqwi';
const LIST_ID = 'Uw3FLb';
export function GiftDay1Section() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const value = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setState('error');
      return;
    }
    setState('sending');
    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Landing · Regalo Día 1',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: value,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: LIST_ID
                }
              }
            }
          }
        })
      });
      setState(res.ok ? 'done' : 'error');
    } catch {
      setState('error');
    }
  };
  return <section id="regalo" className="bg-gradient-section py-14 md:py-20 px-4 md:px-8" data-id="element-132" data-mp="1yph1oz6b79fx">
      <div className="max-w-md mx-auto text-center border border-gold/25 rounded-[12px] px-5 py-9 md:px-8" data-id="element-133" data-mp="1yn497s2xdgom">
        <p className="uppercase tracking-[0.24em] text-[#C8A870] font-semibold text-[12px] mb-4" style={{
        fontFamily: 'sans-serif'
      }} data-id="element-134" data-mp="27hrcahl49gxp">
          ¿Todavía no estás segura?
        </p>
        <h2 className="font-display text-[28px] md:text-[34px] leading-tight text-foreground" data-id="element-135" data-mp="2cer7tykcb1ak">
          Probá tu Día 1 gratis
        </h2>
        <p className="mt-4 font-body text-foreground/65 text-[16px] leading-relaxed" data-id="element-136" data-mp="hd5y7n7iwryi">
          Recibí el Día 1 de la app Mi H.E.R.: la rutina de la Fase H, una receta y una sesión de movilidad. Así ves cómo es antes de decidir.
        </p>

        {state === 'done' ? <div className="mt-7 flex flex-col items-center gap-3" role="status" data-id="element-137" data-mp="r5lbw8bseudl">
            <span className="w-10 h-10 rounded-full border border-gold/50 flex items-center justify-center" data-id="element-138" data-mp="mbh6vum30wf5"><CheckIcon className="w-5 h-5 text-[#C8A870]" data-id="element-139" data-mp="102lzicr18ofz" /></span>
            <p className="font-body text-foreground text-[16px]" data-id="element-140" data-mp="w3d473gcgiib">Listo. Revisá tu email: ahí está el enlace a tu Día 1.</p>
            <p className="font-body text-foreground/50 text-[13px]" data-id="element-141" data-mp="1a11nw7yodjls">Si no aparece en unos minutos, mirá en Promociones o Spam.</p>
          </div> : <form onSubmit={submit} className="mt-7 space-y-3" noValidate data-id="element-142" data-mp="151gu0byd41fx">
            <label htmlFor="regalo-email" className="sr-only" data-id="element-143" data-mp="3btzpotafjmiv">Tu email</label>
            <input id="regalo-email" type="email" inputMode="email" autoComplete="email" required placeholder="Tu email" value={email} onChange={e => {
          setEmail(e.target.value);
          if (state === 'error') setState('idle');
        }} className="w-full h-12 px-4 rounded-[4px] bg-black/20 border border-gold/30 text-foreground text-[16px] placeholder:text-foreground/40 focus:outline-none focus:border-gold" data-id="element-144" data-mp="36vy709gx1p7x" />
            <button type="submit" disabled={state === 'sending'} className="w-full h-12 inline-flex items-center justify-center gap-2 bg-[#C8A870] text-[#1a1410] rounded-[4px] uppercase tracking-[0.12em] text-[13px] font-semibold disabled:opacity-60" data-id="element-145" data-mp="1hkuaj4lvziij">
              {state === 'sending' ? 'Enviando…' : <>Quiero mi Día 1 <ArrowRightIcon className="w-4 h-4" data-id="element-146" data-mp="tp88tucahguw" /></>}
            </button>
            {state === 'error' && <p className="text-[13px] text-red-300" role="alert" data-id="element-147" data-mp="ynt197lauw8s">Revisá el email e intentá de nuevo.</p>}
            <p className="font-body text-foreground/50 text-[13px] leading-relaxed" data-id="element-148" data-mp="2o2hd97pzac6a">
              Te llega el enlace a tu email. Sin pagar nada. También vas a recibir emails de H.E.R.; podés darte de baja cuando quieras.
            </p>
          </form>}
      </div>
    </section>;
}